import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "listings scroll-wrapper" }
const _hoisted_3 = { class: "listings-header" }
const _hoisted_4 = {
  key: 0,
  class: "items-count"
}
const _hoisted_5 = {
  key: 1,
  class: "items-count"
}
const _hoisted_6 = { class: "wrapper-table" }
const _hoisted_7 = { class: "table-scroll" }
const _hoisted_8 = { class: "table-default" }
const _hoisted_9 = { class: "checkbox" }
const _hoisted_10 = { class: "controls" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "select-imported-listing-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("div", { class: "modal-title" }, "Select listing(s)")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.getListingsSelectedCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.plural($setup.getListingsSelectedCount, "Listing")) + " selected", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.plural($props.listings.length, "Listing")), 1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.listings, (item, idx) => {
                      return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                        _createElementVNode("td", _hoisted_9, [
                          _createVNode($setup["CheckboxInput"], {
                            label: $setup.getLabel(item),
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                            modelValue: item.isSelected,
                            "onUpdate:modelValue": ($event: any) => (item.isSelected = $event)
                          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "button default",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.close()))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary send",
            onClick: $setup.onSubmit,
            disabled: !$props.listings.length || $setup.loading || !$setup.getListingsSelectedCount
          }, _toDisplayString($setup.loading ? "Importing..." : "Confirm"), 9, _hoisted_11)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}